var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.15675 10.2381L1.31075 11.3921H3.68975L4.84375 10.2381C5.05275 10.0291 5.05275 9.69012 4.84375 9.48112L2.87875 7.51612C2.66975 7.30712 2.33075 7.30712 2.12175 7.51612L0.15675 9.48112C-0.05225 9.69012 -0.05225 10.0291 0.15675 10.2381Z",
    fill: "#799088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84375 1.154L3.68975 0H1.31075L0.15675 1.154C-0.05225 1.363 -0.05225 1.702 0.15675 1.911L2.12175 3.876C2.33075 4.085 2.66975 4.085 2.87875 3.876L4.84375 1.911C5.05275 1.702 5.05275 1.363 4.84375 1.154Z",
    fill: "#799088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04281 8.04004L8.19681 6.88604V4.50704L7.04281 3.35304C6.83381 3.14404 6.49481 3.14404 6.28581 3.35304L4.32081 5.31804C4.11181 5.52704 4.11181 5.86604 4.32081 6.07504L6.28581 8.04004C6.49481 8.24904 6.83381 8.24904 7.04281 8.04004Z",
    fill: "#799088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.827e34e711468465ea8671be48d6cbd5.svg";
export { ForwardRef as ReactComponent };